"use client"

import { Container, NewText, useIsDesktop } from "ui"
import { sharedColors } from "ui/theme/colors"
import Slider from "../Slider"
import WhiteBgHeading from "./ApartmentMarketingForRent/WhiteBgHeading"

type Props = {
  locale: string
  gallery: Array<{
    imageOrVideoSelectorMobaile?: string
    imageOrVideoSelsctor?: string
  }>
  homepage?: boolean
  header?: {
    title?: string
    subTitle?: string
  }
  style?: React.CSSProperties
  swiperContainerProps?: {
    [key: string]: any
  }
  newStylePagination?: boolean
  slideHeight?: number
  mobileSlideHeight?: number
  expandIcon?: boolean
  swiperBorderRadius?: number
  rentProjectInterestedNum?: number
}

// const Styled

function Gallery({
  gallery,
  locale,
  homepage,
  header,
  style,
  swiperContainerProps,
  newStylePagination,
  slideHeight,
  mobileSlideHeight,
  expandIcon,
  swiperBorderRadius,
  rentProjectInterestedNum,
}: Props) {
  const isDesktop = useIsDesktop()

  const numberOfInterest =
    typeof rentProjectInterestedNum === "number" ? String(rentProjectInterestedNum) : null

  return (
    <Container
      style={{
        paddingTop: isDesktop ? (homepage ? "40px" : "60px") : homepage ? "40px" : "32px",
        paddingBottom: isDesktop ? (homepage ? "40px" : "0") : homepage ? "40px" : "0",
        ...style,
      }}
    >
      {header && (
        <>
          <WhiteBgHeading
            title={header.title}
            subTitle={header.subTitle}
            desktopMarginBottom={40}
            mobileMarginBottom={32}
          />
        </>
      )}
      {/* Render the gallery slider if there are images/videos */}
      {gallery && gallery.length > 0 ? (
        <Slider
          gallery={gallery}
          locale={locale}
          swiperContainerProps={swiperContainerProps}
          newStyle={newStylePagination}
          slideHeight={slideHeight}
          mobileSlideHeight={mobileSlideHeight}
          expandIcon={expandIcon}
          swiperBorderRadius={swiperBorderRadius}
          numberOfInterest={numberOfInterest}
        />
      ) : null}
      <NewText
        component="p"
        desktopFontSize={14}
        desktopLineHeight={"150%"}
        desktopFontWeight={300}
        color={sharedColors.newBlack}
        sx={{
          marginTop: {
            xs: "8px",
            md: "0",
          },
          paddingInline: {
            xs: "16px",
            md: "33px",
          },
        }}
      >
        *התמונות להמחשה בלבד
      </NewText>
    </Container>
  )
}

export default Gallery
